var render = function render(){var _vm=this,_c=_vm._self._c;return _c('item-wrapper',[_c('template',{slot:"title"},[_c('title-wrapper',{attrs:{"title":"工单周期统计"}})],1),_c('template',{slot:"content"},[_c('cycles',_vm._g({},_vm.$listeners))],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }